import { render, staticRenderFns } from "./access-restricted.vue?vue&type=template&id=017d0739&"
import script from "./access-restricted.vue?vue&type=script&lang=js&"
export * from "./access-restricted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports